import React, { FC, ReactElement } from 'react'
import { styled } from 'styled-components'

const nodeClassName = 'styled-map-toggle'

const StyledContainer = styled.div<{ $enabled: boolean }>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.55rem;

  .${nodeClassName} {
    height: 100%;
    width: 100%;
    color: ${({ theme }) => theme.forecast.icon1};
    transition: all 0.2s;
    opacity: ${({ $enabled }) => ($enabled ? 1 : 0.37)};
  }
`

interface StyledMapToggleProps {
  icon: ReactElement
  enabled: boolean
}
/** A styled map toggle that is un-memoized.  This is important because we use React.cloneElement, an expensive operation */
const StyledMapToggleUnMemo: FC<StyledMapToggleProps> = ({ icon, enabled }) => {
  const styledIcon = React.cloneElement(icon, {
    className: `${icon.props.className ?? ''} ${nodeClassName}`,
  })

  return <StyledContainer $enabled={enabled}>{styledIcon}</StyledContainer>
}

/**
 * A component that styles a React Element to be consistent with other map toggles
 *
 * NOTE: This component is memoized, and will only re-render if the `enabled` prop changes
 */
export const StyledMapToggle = React.memo(
  StyledMapToggleUnMemo,
  (prev, next) => prev.enabled === next.enabled
)
